<script>
export default {
  props: {
    module: Object,
  },
  data: () => ({
    active: false,
  }),
};
</script>
<template>
  <Card fixed-top v-if="module">
    <CardTitle>Бронирование</CardTitle>
    <CardBody>
      <div class="p-t-c-ip__group">
        <div class="p-t-c-ip__name">
          Дата:
        </div>
        <div class="p-t-c-ip__value">
          {{module.date | date}}
        </div>
      </div>

      <div class="p-t-c-ip__group">
        <div class="p-t-c-ip__name">
          Стоимость тура:
        </div>
        <div class="p-t-c-ip__value">
          {{module.price | price}} {{'rub' | currency}}
        </div>
      </div>
      <div class="p-t-c-ip__group">
        <div class="p-t-c-ip__name">
          Дополнительные услуги:
        </div>
        <div class="p-t-c-ip__value">
          {{module.servicePrice | price}} {{'rub' | currency}}
        </div>
      </div>
      <div class="p-t-c-ip__group" >
        <div class="p-t-c-ip__name">
          Стоимость отеля:
        </div>
        <div class="p-t-c-ip__value">
          {{module.hotel | price}} {{'rub' | currency}}
        </div>
      </div>

      <div class="p-t-c-ip__group">
        <div class="p-t-c-ip__name">
          Общая стоимость:
        </div>
        <div class="p-t-c-ip__value">
          {{module.allPrice | price}} {{'rub' | currency}}
        </div>
      </div>
      <div class="p-t-c-ip__cancellation" v-if="module.cancellation">
        <span @click="active=true">Условия аннуляции</span>
      </div>
    </CardBody>
    <Dialog
      title="Условия аннуляции"
      width="700px"
      :active.sync="active"
    >
      <div v-html="module.cancellation"></div>
    </Dialog>
    <CardFooter>
      <BtnPrimary
        @click="$emit('submit')"
      >Забронировать
      </BtnPrimary>
    </CardFooter>
  </Card>
</template>
<style lang="scss">
  .p-t-c-ip {
    &__group {
      display: flex;
      margin: 0 0 8px 0;
    }

    &__name {
      flex: 1;
    }

    &__value {
      width: 100px;
      flex-shrink: 0;
      font-weight: 700;
      text-align: right;
    }

    &__cancellation {
      text-align: center;
      margin: 8px 0 8px 0;
      padding: 8px;
      background: #e1bcba;
      color: #333333;
      border-radius: 8px;

      span {
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
</style>
